import { NavigableElement } from '../../../CfDataGridProps';
import { StyledGridCell } from '../../DataGridTableView/row/row.styles';
import { CfDataGridCellBaseProps } from './common';

export interface CfDataGridCellProps<TItem> extends CfDataGridCellBaseProps<TItem> {
  item: TItem | undefined;
}

export function CfDataGridCell<TItem>(props: CfDataGridCellProps<TItem>): JSX.Element {
  const { item, getter, itemIndex, columnIndex, filterText, setNavigableElement } = props;
  const column = getter.column;
  const bodyCellProps =
    typeof column.bodyCellProps === 'function' ? column.bodyCellProps(item, props.itemIndex) : column.bodyCellProps;

  return (
    <StyledGridCell
      {...bodyCellProps}
      sx={{
        ...(itemIndex > 0 && { borderTop: (theme) => '1px solid ' + theme.palette.coolGrey[200] }),
        textAlign: getter.column.horizontalAlignment,
        width: getter.column.width,
        ...bodyCellProps?.sx,
      }}
    >
      {/* Loading Placeholder */}
      {!item &&
        (typeof column.loadingPlaceholder === 'function'
          ? column.loadingPlaceholder(column, props.itemIndex)
          : column.loadingPlaceholder || '')}

      {/* Cell Contents */}
      {item &&
        getter.getValue({
          item: item,
          itemIndex: itemIndex,
          filterText: filterText,
          setNavigableElement: (navigableElement: NavigableElement) =>
            setNavigableElement(navigableElement, itemIndex, columnIndex),
        })}
    </StyledGridCell>
  );
}
